import React from 'react';
import {_countryNameFromCode} from '../helpers/helpers.js'

interface CountryFlagAndNameProps {
    countryCode: string;
}

function _getFlagCodeFromCountryCode(countryCode: string): string {
    if (countryCode == 'UK') return 'GB';
    return countryCode;
}

export default function CountryFlagAndName({countryCode}: CountryFlagAndNameProps) {
    const flagCode = _getFlagCodeFromCountryCode(countryCode);
    const ctrName = _countryNameFromCode(countryCode);
    return (
        <>
        {
            flagCode.length >0 ?
            <>
                <img 
                    src={`/s/ci/${flagCode}.png`} 
                    title={flagCode} 
                    width="25"
                    height="13" 
                />
                {' '}{ctrName}
            </>   
            :
            <>           
            </>           
        }
        </>
)
}